<template>
  <div class="renderjson_container">
    <div v-bind:id="id" class="renderjson_wrapper"/>

    <div v-if="!no_expand_hide"
         id="expand_hide"
         @click="on_expand_hide">
      {{expand_hide}} All
    </div>
  </div>
</template>

<script>
import style from './renderjson.css'
import renderjson from './renderjson.js'

renderjson.set_show_to_level(1);

export default {
  name: 'renderjson',

  props : {
    data : {},
    level : null,
    no_expand_hide : Boolean
  },

  data : function(){
    return {
      expanded : false
    }
  },

  computed : {
    expand_hide : function(){
      return this.expanded ? 'Hide' : 'Expand';
    },

    id : function(){
      return "renderjson-" + Math.random();
    },

    rendered : function(){
      return renderjson(this.data);
    }
  },

  watch : {
    rendered : function(){
      var div = document.getElementById(this.id);
      div.innerHTML = "";
      div.appendChild(this.rendered)
    }
  },

  methods : {
    on_expand_hide : function(){
      if(this.expanded)
        this.rendered.hide_all();
      else
        this.rendered.show_all();

      this.expanded = !this.expanded;
    }
  },

  mounted : function(){
    if(this.level)
      renderjson.set_show_to_level(this.level);

    var div = document.getElementById(this.id);
    var rendered = renderjson(this.data);
    div.appendChild(rendered)
  },

  beforeDestroy : function(){
  },
}
</script>

<style scoped>
.renderjson_container{
  display: flex;
  flex-direction: column;
}

.renderjson_wrapper{
  flex-grow: 1;
}

#expand_hide{
 cursor: pointer;
 text-align: right;
 color: blue;
}
</style>

<style>
.renderjson{
  margin-bottom: 0;
  background-color: white;
  padding: 15px;
}
</style>
